import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const MuteIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon {...props} viewBox="0 0 24 24">
            <g>
                <path fill="currentColor" d="M22.001,16.75c-0.229,0-0.454-0.104-0.601-0.3l-6-8c-0.249-0.332-0.182-0.802,0.149-1.05
                    c0.333-0.249,0.803-0.181,1.05,0.15l6,8c0.249,0.332,0.182,0.802-0.149,1.05C22.315,16.701,22.157,16.75,22.001,16.75z"/>
            </g>
            <g>
                <path fill="currentColor" d="M15.999,16.75c-0.156,0-0.314-0.049-0.449-0.15c-0.331-0.249-0.398-0.719-0.149-1.05l6-8
                    c0.246-0.332,0.718-0.4,1.05-0.15c0.331,0.249,0.398,0.719,0.149,1.05l-6,8C16.453,16.646,16.228,16.75,15.999,16.75z"/>
            </g>
            <g>
                <path fill="currentColor" d="M11.5,4.692v14.622l-3.45-3.384L7.613,15.5H7H3c-0.271,0-0.5-0.229-0.5-0.5V9c0-0.271,0.229-0.5,0.5-0.5h4
                    h0.612L8.05,8.072L11.5,4.692 M11.99,2.5c-0.243,0-0.49,0.089-0.691,0.288L7,7H3C1.897,7,1,7.907,1,9v6c0,1.093,0.897,2,2,2h4
                    l4.29,4.209c0.203,0.201,0.453,0.291,0.698,0.291c0.516,0,1.012-0.399,1.012-0.999V3.498C13,2.9,12.505,2.5,11.99,2.5L11.99,2.5z"
                    />
            </g>
        </SvgIcon>
    );
};
